import { Component, OnInit } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IUpdateUserPasswordPayload } from "src/app/models/user/update-user-password-payload";
import { ClientService } from "src/app/services/client.service";
import { ModalService } from "src/app/services/modal.service";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: "app-password",
  templateUrl: "./password.component.html",
  styleUrls: ["./password.component.scss"],
})
export class PasswordComponent implements OnInit {
  private readonly _PASSWORD_REG_EXP = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\W).*$/;

  login = "";
  email = "";
  oldPassword = "";
  newPassword = "";
  repeatPassword = "";
  isPasswordLocked = true;
  isLoading = true;

  constructor(
    private _clientService: ClientService,
    private _userService: UserService,
    private _modalService: ModalService
  ) {}

  get isRepeatPasswordValid() {
    return this.repeatPassword === this.newPassword;
  }

  get areInputsInvalid(): boolean {
    return (
      this.oldPassword.length < 2 ||
      this.newPassword.length < 8 ||
      !this._PASSWORD_REG_EXP.test(this.newPassword) ||
      !this.isRepeatPasswordValid
    );
  }

  updatePassword() {
    const payload: IUpdateUserPasswordPayload = {
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
    };

    this._userService.updatePassword(payload).subscribe({
      next: () => {
        this.oldPassword = "";
        this.newPassword = "";
        this.repeatPassword = "";
        this._modalService.openModal(ModalName.Success);
      },
    });
  }

  togglePasswordLock() {
    this.isPasswordLocked = !this.isPasswordLocked;
  }

  ngOnInit() {
    this.getClientInfo();
  }

  private getClientInfo() {
    this._clientService.getClientInfo().subscribe(clientInfo => {
      this.login = clientInfo.login;
      this.email = clientInfo.email;
      this.isLoading = false;
    });
  }
}
